import type { ConfigurationsType } from "@dexteel/mesf-core/dist/configurationMenu";
import { useHasPermission } from "@dexteel/mesf-core";
import { Construction } from "@mui/icons-material";
import {
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import CraftsPage, { CRAFTS_PERMISSION } from "./configurations/crafts";

const components = [
	{
		path: "crafts",
		sidebar: () => <div>Crafts</div>,
		main: CraftsPage,
	},
];

const sidebar = ({ option }: { option?: string }) => {
	const theme = useTheme();
	const hasPermissionTo = useHasPermission();

	if (!hasPermissionTo(CRAFTS_PERMISSION)) return null;

	return (
		<List
			subheader={
				<ListSubheader
					style={{
						backgroundColor: theme.palette.background.paper,
						color: theme.palette.primary.main,
						fontWeight: 600,
					}}
				>
					Maintenance Settings
				</ListSubheader>
			}
		>
			<ListItem disablePadding>
				<ListItemButton
					selected={option === "crafts"}
					component={Link}
					to="/configuration/crafts"
				>
					<ListItemIcon>
						<Construction />
					</ListItemIcon>
					<ListItemText primary="Crafts" />
				</ListItemButton>
			</ListItem>
		</List>
	);
};
const customConfigurations: ConfigurationsType = [components, sidebar];

export { customConfigurations };
